export const formatNumberLocalized = (locale, amount, minFractionDigits = 0, maxFractionDigits = 0) => {
  locale = locale === 'fr' ? 'fr-CA' : 'en-CA';
  if (!amount || isNaN(amount)) {
    amount = 0;
  }

  return new Intl.NumberFormat(locale, {
    style: 'decimal',
    minimumFractionDigits: minFractionDigits,
    maximumFractionDigits: maxFractionDigits
  }).format(amount);
};